import React, { FC } from 'react';
import { AddCommodityAttachmentError, AddWorkPackageAttachmentError } from '@bechtel/types';
import { Box, Text, Button, ButtonAppearance } from '@bechtel/gds';
import { Modal, ModalBody, ModalFooter } from '@bechtel/gds';
import { ModalHeaderStyled } from '~/components';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';

interface AddWorkPackageAttachmentErrorProps {
  error: AddWorkPackageAttachmentError | ApolloError | AddCommodityAttachmentError;
  close: () => void;
}

const getErrorMessage = (error: AddWorkPackageAttachmentError | AddCommodityAttachmentError | ApolloError) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please click on the close button and try again.</Trans>;
  }
  switch (error) {
    case AddWorkPackageAttachmentError.INVALID_WORK_PACKAGE_ID:
    case AddWorkPackageAttachmentError.WORK_PACKAGE_NOT_FOUND:
      return <Trans>The workpackage is not valid and attachments cannot be uploaded.</Trans>;
    case AddCommodityAttachmentError.INVALID_COMMODITY_ID:
    case AddCommodityAttachmentError.COMMODITY_NOT_FOUND:
      return <Trans>The commodity is not valid and attachments cannot be uploaded.</Trans>;
    case AddCommodityAttachmentError.SERVICE_PROXY_ERROR:
    case AddWorkPackageAttachmentError.SERVICE_PROXY_ERROR:
      return <Trans>Downstream service is down. Please try again after sometime. </Trans>;
    default:
      return <Trans>An error has occured .Please click on the close button and try again.</Trans>;
  }
};

export const DocumentUploadError: FC<AddWorkPackageAttachmentErrorProps> = ({ error, close }) => {
  return (
    <Modal visible>
      <ModalHeaderStyled title={t`Document upload error`}></ModalHeaderStyled>
      <ModalBody>
        <Box px={{ sm: '500' }} py={{ sm: '700' }}>
          <Text size="600">{getErrorMessage(error)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
